module.exports = __webpack_public_path__ + "static/media/home-3.d5bdb1ce.png";